<template>
  <div class="top center" :class="isMain ? 'not-right' : ''">
    <div v-if="!isMain" class="top-nav clear center-left">
      <ul class="nav nav-menu">
        <li :class="!menuInfo.subTitle ? 'select-nav' : ''"><a @click="goMenu(menuInfo.mainTitle)">{{ menuInfo.mainName }}</a></li>
        <li v-if="menuInfo.subTitle"><p><img src="/static/img/ico-arrow-line-S-blue@2x.png" alt=""></p></li>
        <li v-if="menuInfo.subTitle" class="select-nav"><a @click="goMenu(menuInfo.subTitle)">{{ menuInfo.subName }}</a></li>
      </ul>
    </div>
    <div class="top-btn center-right">
      <div class="btn-logout">
        <button class="btn btn-40" @click="logout"><span><img src="/static/img/ico-logout-white@2x.png" alt=""></span></button>
      </div>
      <div class="user-info">
        <span>{{ userID }}</span>님
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-continue */

import Configuration from '@/js/Configuration';
import UpdateModal from '@/components/account/UpdateModal';

export default {
  props: [
    'menuInfo',
    'isMain',
  ],
  components: {
    UpdateModal,
  },
  data: () => ({
    uID: null,
    userID: null,
    name: null,
    modal: false,
    user: {
      uID: null,
      userID: null,
      name: null,
      role: null,
      passwd: null,
      manager: null,
      operator: null,
      monitor: null,
    },
  }),
  created() {
    if (this.$cookie.get('accessToken')) {
      const token = this.$jwtDecode(this.$cookie.get('accessToken'));
      this.userID = token.userID;
      this.name = token.name;
      this.uID = token.uID;
    }
  },
  methods: {
    goMenu(menuName) {
      this.$router.push({ name: menuName }).catch(() => {});
    },
    async logout() {
      try {
        const res = await this.$http.put(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/user/logout/${this.uID}`,
          {
            userID: this.userID,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }
      } catch (e) {
        alert('로그아웃에 실패하였습니다.');
        console.error(e);
      }

      //
      this.$deleteCookie();
      this.$router.push({ name: 'Login' });
    },
    async updateUser() {
      try {
        const role = this.$jwtDecode(this.$cookie.get('accessToken')).role;
        if (role === 0 || role === 1) return;

        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/user/${this.uID}`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (result.status !== 200) {
          throw new Error(`Response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${result.data.resultCode}"`);
        }

        this.user.uID = result.data.user.uID;
        this.user.userID = result.data.user.userID;
        this.user.name = result.data.user.name;
        this.user.role = result.data.user.role;
        this.user.email = result.data.user.email;
        this.user.mobile = result.data.user.mobile;
        this.user.manager = result.data.user.manager;
        this.user.operator = result.data.user.operator;
        this.user.monitor = result.data.user.monitor;
        this.modal = true;
      } catch (e) {
        console.error(e);
      }
    },
    closeModal() {
      this.modal = false;
    },
    reloadData() {
      this.modal = false;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/include/Navigation.vue